<!-- 系统管理-菜单管理 -->
<template>
  <div v-if="!qrcodePageShow && !importMember">
    <!-- 卡片 -->
    <div class="md-layout" style="flex-wrap: nowrap;">
      <!-- 左侧-部门选择 -->
      <div class="md-layout-item" style="max-width: 280px; min-width: 240px; padding-left: 0;padding-right: 0;">
        <md-card>
          <!-- 卡片-主体 -->
          <md-card-content>
            <!-- 添加按钮 -->
            <div style="margin-bottom: 12px;">
              <md-button class="diy-blue has-button" @click="table_addDept" style="width: 100%;">
                <md-icon>add</md-icon>
                {{$I18n("add_depart")}}
              </md-button>
            </div>
            <!-- 筛选-Input -->
            <div style="position: relative;">
              <common-form-item 
                style="margin-bottom: 16px;"
                :labelweight="100"
                v-model="tree_filter" 
                type="input"
                placeholder=""
              />
              <md-icon class="search-icon">search</md-icon>
            </div>
            <!-- 部门 -->
            <p style="margin: -10px 0 4px;font-weight: 500;">{{organi_name}}</p>
            <tree
              ref="tree"
              node-key="_id"
              :props="treeDefaultProps"
              :data="deptData"
              @node-collapse="closeExpd"
              @node-expand="openExpd"
              :default-expanded-keys="defaultExpd"
              :filter-node-method="filterNode"
            >
              <div class="custom-tree-node diy-tree-node" slot-scope="{ data }" :class="{
                'selected-tree': dept_id === data._id,
              }" @click="(event) => changeTree(data, event)">
                <span 
                  v-if="data.children && data.children.length > 0"
                  :ref="'tree_'+data._id"
                  @click="(event) => expandedTree(data, event)"
                  class="el-tree-node__expand-icon el-icon-caret-right TTT" 
                  :class="{'expanded': defaultExpd.includes(data._id)}"
                ></span>
                <span class="diy-tree-title">{{ data.name }}</span>
                <div v-if="data.def !== 1" class="tree-button" @click.stop @click="e => e.stopPropagation()">
                  <drop-down>
                    <div>
                      <md-icon style="font-size: 18px !important;">more_vert</md-icon>
                    </div>
                    
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li @click="() => table_setDept(data)">
                        <a>{{ $I18n("compiler") }}</a>
                      </li>
                      <li @click="() => table_delDept(data)">
                        <a>{{ $I18n("delete") }}</a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </div>
            </tree>
          </md-card-content>
        </md-card>
      </div>
      <!-- 右侧-主要表格 -->
      <div class="md-layout-item" style="padding-right: 0;">
        <md-card>
          <!-- 卡片-主体 -->
          <md-card-content>
            <!-- 顶部-表单+按钮 -->
            <div style="margin-bottom: 12px;">
              <div class="table-form-box">
                <!-- 手机号/邮箱/姓名/卡号/工号 -->
                <div style="display: inline-block;width: 300px;">
                  <common-form-item 
                    v-model="searchForm.like"
                    type="input"
                    :placeholder="$I18n('phone_mail_name_card_work')"
                    :bigBorder="true"
                  />
                </div>
                <!-- 人员类型，包含黑名单、白名单 -->
                <div style="display: inline-block;width: 300px; margin-right: 25px;">
                  <common-form-item 
                    :labelweight="100"
                    v-model="searchForm.list_type" 
                    type="select"
                    :options="[
                      {
                        id: 0,
                        name: $I18n('all'),
                      },
                      ...memberType,
                    ]"
                    :label="$I18n('person_select')"
                    :placeholder="$I18n('pls_select')"
                    :bigBorder="true"
                  />
                </div>
                <div style="display: flex;">
                  <!-- 查询 -->
                  <md-button class="big-button diy-back-blue has-button" @click="goSearch">
                    <md-icon>search</md-icon>
                    {{$I18n("consult")}}
                  </md-button>
                  <!-- 重置 -->
                  <md-button class="diy-blue has-button" @click="resetSearch">
                    <md-icon>refresh</md-icon>
                    {{$I18n("reprovision")}}
                  </md-button>
                </div>
              </div>
              <div class="table-button-box">
                <!-- 添加人员 -->
                <md-button v-if="nowOrgItem.role_id === 1" class="diy-blue has-button" @click="table_addUser">
                  <md-icon>add</md-icon>
                  {{$I18n("add_person")}}
                </md-button>

                <!-- 导入 -->
                <md-button class="diy-blue has-button" @click="() => importMember = true">
                  <md-icon>add</md-icon>
                  {{$I18n("import")}}
                </md-button>
                <!-- 导出 -->
                <md-button class="diy-blue has-button" @click="() => {}" style="cursor: no-drop;">
                  <md-icon>download</md-icon>
                  {{$I18n("export")}}
                </md-button>
                <!-- 邀请人员 -->
                <md-button class="diy-blue has-button" @click="goQrCodeSet">
                  <md-icon>add</md-icon>
                  {{$I18n("invi_mem")}}
                </md-button>
                <!-- 人员部门转移 -->
                <md-button class="diy-blue has-button" @click="table_changeMemberDept">
                  <md-icon>content_copy</md-icon>
                  {{$I18n("depart_tran")}}
                </md-button>
                <!-- 人员下发 -->
                <md-button class="diy-blue has-button right-icon" @click="() => {}" style="cursor: no-drop;">
                  {{$I18n("person_dis")}}
                  <md-icon>download</md-icon>
                </md-button>
                <md-button class="diy-blue has-button svg-icon" @click="batchDelete">
                  <img src="/img/haiqora/trash.png" style="width: 16px;height: 16px;"/>
                  {{$I18n("batch_del")}}
                </md-button>
              </div>
            </div>
            <!-- 表格 -->
            <md-table class="diy-gray" v-model="tableData" @md-selected="table_selectMember" :md-selected-value.sync="selTable">
              <md-table-row 
                slot="md-table-row" 
                slot-scope="{ item }" 
                md-selectable="multiple"
                md-auto-select
              >
                <!-- 注册照片 -->
                <md-table-cell :md-label="$I18n('regis_photo')">
                  <el-tooltip v-if="item.user_icon" placement="right">
                    <div slot="content" style="margin: -9px;">
                      <img :src="item.user_icon"/>
                    </div>
                    <img :src="item.user_icon" style="max-width: 50px;max-height: 50px;" />
                  </el-tooltip>
                  <img v-else src="/img/haiqora/face.png" class="table-image"/>
                </md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.user_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('sectoral')">{{ item.dept_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('phone')">{{ item.phone }}</md-table-cell>
                <md-table-cell :md-label="$I18n('card_num')">{{ item.card_num ?item.card_num :"" }}</md-table-cell>
                <md-table-cell :md-label="$I18n('work_num')">{{ item.job_num }}</md-table-cell>
                <md-table-cell :md-label="$I18n('list_state')">{{ item.list_state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('person_type')">{{ item.person_type_name }}</md-table-cell>
                <md-table-cell v-if="nowOrgItem.role_id === 1" :md-label="$I18n('operate')" class="button-cell">
                  <template v-if="UserInfo.user_id !== item.user_id">
                    <md-button @click="table_editUser(item)" @click.stop class="md-simple md-info">
                      {{$I18n("compiler")}}
                    </md-button>
                    <md-button @click.stop class="md-simple md-info " style="cursor: no-drop;">
                      {{$I18n("departure")}}
                    </md-button>
                    <md-button @click.stop class="md-simple md-info " style="cursor: no-drop;">
                      {{$I18n("particulars")}}
                    </md-button>
                    <md-button @click="table_delUser(item)" @click.stop class="md-simple md-info ">
                      {{$I18n("remove")}}
                    </md-button>
                  </template>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
            </md-table>
            <table-page :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <modal-member ref="member" @close="api_getPageData" :organi="sel_organi" :deptData="deptData"/>
    <modal-dept   ref="dept"   @close="regetDept" :organi="sel_organi" :deptData="deptData"/>

    <!-- 批量人员转移 -->
    <simple-modal 
      ref    = "change_dept"
      :title = "modal_title"
      :right = "true"
      :middle= "true"
      @submit= "change_dept_submit"
      @close = "closeModal"
    >
      <template slot="body">
        <div class="md-layout">
          <div class="md-layout-item md-size-50">
            <!-- 筛选-Input -->
            <div style="position: relative;">
              <common-form-item 
                style="margin-bottom: 16px;"
                :labelweight="100"
                v-model="tree_filter_modal"
                type="input"
                placeholder="test-filter"
              />
              <md-icon class="search-icon">search</md-icon>
            </div>
          </div>
          <div class="md-layout-item md-size-50"></div>

          <div class="md-layout-item md-size-50">
            <div style="width: 100%;min-height: 10px;border-radius: 7px;border: 1px solid #BCBCBC;padding: 5px;">
              <tree
                ref="tree_modal"
                node-key="_id"
                :props="treeDefaultProps"
                :data="deptData"
                :filter-node-method="filterNode"
              >
              <!-- diy-tree-node -->
                <div slot-scope="{ data }">
                  <div style="padding-left: 6px;">
                    <md-radio class="diy-radio-class small-size" v-model="tree_select_modal" :value="data._id">
                      <span style="font-size: 14px;color: #000;">{{ data.name }}</span>
                    </md-radio>
                  </div>
                </div>
              </tree>
            </div>
          </div>

          <div class="md-layout-item md-size-50">
            <div style="width: 100%;min-height: 10px;border-radius: 7px;border: 1px solid #BCBCBC;padding: 5px;">
              <div style="border-bottom: 1px solid #BCBCBC;line-height: 40px; height: 40px; margin: -5px -5px 0; padding: 0 10px;font-size: 14px;color: #000;">
                {{"Elected"}}
              </div>
              <div style="line-height: 40px;padding:0 5px;">
                <md-radio class="diy-radio-class" v-model="tree_select_modal" :value="tree_select_modal">
                  <span style="font-size: 14px;color: #000;">{{ tree_select_modal_data.name }}</span>
                </md-radio>
              </div>
            </div>
          </div>
        </div>
      </template>
    </simple-modal>
  </div>
  <div v-else-if="qrcodePageShow">
    <md-card class="qrcode-box" style="min-height: calc(100vh - 160px);">
      <!-- 卡片-主体 -->
      <md-card-content>
        <h4 >{{$I18n("prcode_01")}}</h4>
        <div class="qr-box" style="position:relative;">
          <div class="ex-shadow" v-if="nowOrgItem.qrcode_expire_type === 2 && new Date(exp_time) < new Date()">
            <!-- <md-icon class="ex-icon">autorenew</md-icon> -->
          </div>
          <div class="qr-info">{{$I18n("prcode_02")}}</div>
          <div class="qr-img">
            <div style="background: #FFF; width: 240px;text-align: center;margin-bottom: 8px;">
              <vue-qrcode :value="qrcodeURL"/>
            </div>
            <div style="color: #F99532;text-align: center;">
              {{$I18n("prcode_03")}}
            </div>
          </div>
        </div>
        <div v-if="nowOrgItem.role_id === 1">
          <h4>{{$I18n("prcode_04")}}</h4>
          <common-form-item 
            :labelweight="100"
            v-for="item in formItem_qrcode" 
            v-model="formData_qrcode.Form[item.keys]" 
            :error="formData_qrcode.Error[item.keys]" 
            :key="item.keys" v-bind="item"
            :flex_one="true"
            :style="item.keys === 'icon' ?{'align-items': 'flex-start'} :{}"
          >
            <!-- Label -->
            <template slot="label">
              <p class="member-form-label" style="margin:4px 0;margin-right: 20px;">
                <i v-if="item.keys === 'auto_join'" class="more-info-span">!
                  <!-- Tooltip on top -->
                  <md-tooltip md-direction="bottom">{{$I18n("auto_join_help")}}</md-tooltip>
                </i>
                {{item.label_s}}
              </p>
            </template>
            <div slot="tail" v-if="item.keys === 'qrcode_expire_type' && formData_qrcode.Form.qrcode_expire_type === 2"
              style="flex: 1;" 
            >
              <div style="border:1px solid #DCDFE6; border-radius: 4px;width: 242px;height: 32px;padding-left:5px;display: flex;align-items: center;overflow: hidden;max-width: 300px;">
                <div style="width: 140px;">
                  {{formData_qrcode.Form.qrcode_expire[0].split(" ")[0]}} ~ 
                </div>
                <el-date-picker
                  class="md-date-form-item"
                  align="left"
                  :clearable="false"
                  v-model="formData_qrcode.Form.qrcode_expire[1]"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :start-placeholder="$I18n('start')"
                  :end-placeholder="$I18n('end')">
                </el-date-picker>
                <!-- 
                  range-separator=" ~ " -->
              </div>
            </div>
          </common-form-item>
        </div>
        <div style="line-height:26px;display: flex;align-items: center;cursor: pointer;" @click="regetOrg">
          <span>{{$I18n("prcode_07")}} : {{nowOrgItem.gmt_qrcode_expire ?exp_time :"0000-00-00"}}</span>
          <span style="padding-left:10px;color: #578EFF;">
            <md-icon style="font-size: 10px;position: relative;top: -2px;color: #578EFF;">autorenew</md-icon>
            {{$I18n("refresh")}}
          </span>
        </div>
        <div style="margin-top: 20px;">
          <md-button class="diy-back-blue" @click="qrcodePageShow = false">
            {{$I18n("back")}}
          </md-button>
          <md-button class="diy-back-blue" @click="setQr" style="margin-left: 15px;">
            {{$I18n("save")}}
          </md-button>
        </div>
        <!-- {{qrcodeURL}} -->
      </md-card-content>
    </md-card>
  </div>
  <member-import :deptData="deptData" v-else-if="importMember"></member-import>
  <div v-else></div>
</template>
<script>
import { Tree } from 'element-ui';
import { FormClass } from "@/common/tools.js";
import { nDaysAgo, timestampToString1000 } from "@/common/tools.js";
import ModalMember from "./ModalMember.vue";
import ModalDept from "./ModalDept.vue";
import MemberImport from "./MemberImport.vue";

import VueQrcode from '@chenfengyuan/vue-qrcode';
export default {
  props:["sel_organi", "organi"],
  components: { Tree, ModalMember, ModalDept, VueQrcode, MemberImport },
  data() {
    return {
      importMember: false,
      test:"",
      // 二维码页面
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date(nDaysAgo(1));
          },
        },
        qrcodePageShow: false,  // 是否打开二维码页面
        formData_qrcode: new FormClass({
          qrcode_expire:[nDaysAgo(0),new Date()],
          qrcode_expire_type: 1,
          auto_join: true,
        }),
      // Tree 相关参数
        defaultExpd: [], // 默认展开项目
        dept_id : 0,     // 选中部门
        deptData: [],    // Tree数据 部门数据
        tree_filter: "",
        treeDefaultProps: {  // TREE 默认数据
          children: 'children',
          label: 'label'
        },
      // 弹窗 Tree 相关
        tree_filter_modal: "", // 弹窗的Tree的筛选输入栏
        tree_select_modal: "", // 弹窗的Tree选择的Data
        modal_title : "", // 弹窗-标题

      // 员工数据
        searchForm  : {
          like: "",
          list_type: 0,
        },
        searchData  : {
          like: "",
          list_type: 0,
        },
        tableData   : [], // 表格-展示数据
        selTable    : [],
        total       : 0,  // 翻页-总数
        pageSize    : 10, // 翻页-size
        currentPage : 1,  // 翻页-第x页
        noRepeat    : false,
        memberType  : [
          ...this.$Param.memberListState.map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          })
        ],
    };
  },
  mounted : function() {
    // 默认值
    this.set_dept(this.UserInfo.depts);
    this.api_getPageData()
  },
  watch: {
    dept_id(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    tree_filter(val){
      this.$refs.tree.filter(val);
    },
    tree_filter_modal(val){
      this.$refs.tree_modal.filter(val);
    },
    pageSize(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    currentPage(){
      this.api_getPageData();
    },
  },
  computed: {
    organi_name(){
      const selOrgani = this.organi.filter(i => i.dept_id == this.sel_organi);
      if(selOrgani.length > 0){
        return selOrgani[0].name
      }
      return ""
    },
    exp_time(){
      if(!this.nowOrgItem){
        return 0
      }
      return timestampToString1000(this.nowOrgItem.gmt_qrcode_expire)
    },
    formItem_qrcode(){
      return [
        {
          label_s : this.$I18n("prcode_05"),
          keys    : "auto_join",
          type    : "switch",
        },{
          label_s : this.$I18n("prcode_06"),
          keys    : "qrcode_expire_type",
          type    : "radio",
          options : [
            {id:1, name: this.$I18n("permanently_valid")},
            {id:2, name: this.$I18n("customizable")}
          ],
        }
        // ,{
        //   label_s : this.$I18n("prcode_07"),
        //   keys    : "qrcode_expire",
        //   // hide    : this.formData_qrcode.Form.qrcode_expire_type === 1,
        // }
      ]
    },
    nowOrgItem(){
      return this.organi.filter(i => i.id === this.sel_organi)[0]
    },
    qrcodeURL(){
      const orgItem = this.nowOrgItem
      return `${
        window.location.origin
      }/manual_entry?lang=${
        this.$router.history.current.query.lang
      }&qrkey=${
        orgItem.qrcode_key
      }&hid=${
        orgItem.id
      }`
    },
    tree_select_modal_data(){
      if(!this.tree_select_modal){
        return {
          name: "",
        };
      }
      return this.getDeptData(this.tree_select_modal, this.deptData)
    },
  },
  methods: {
    // 打开邀请员工页面
      setQr(){
        let start = 0;
        let end   = 0;
        if(this.formData_qrcode.Form.qrcode_expire_type === 2){
          // start = parseInt(new Date(this.formData_qrcode.Form.qrcode_expire[0]).getTime() / 1000);
          start = parseInt(new Date(nDaysAgo(0)).getTime() / 1000);
          end   = parseInt(new Date(this.formData_qrcode.Form.qrcode_expire[1]).getTime() / 1000);
        }
        this.$api.s_Organi({
          ...this.nowOrgItem,
          gmt_qrcode_start: start,
          gmt_qrcode_expire: end,
          auto_join: this.formData_qrcode.Form.auto_join ?2 :1,
          qrcode_expire_type: this.formData_qrcode.Form.qrcode_expire_type,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.$emit('reget_organi')
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      },
      regetOrg(){
        this.$emit('reget_organi');
      },
      goQrCodeSet(){
        const orgItem = this.nowOrgItem
        this.formData_qrcode.Update({
          qrcode_expire: orgItem.gmt_qrcode_expire?[
            timestampToString1000(orgItem.gmt_qrcode_start),
            timestampToString1000(orgItem.gmt_qrcode_expire)
          ] :[nDaysAgo(0),new Date()],
          qrcode_expire_type: orgItem.qrcode_expire_type,
          auto_join : orgItem.auto_join === 2,
        })
        this.qrcodePageShow = true;
      },
    // TREE 逻辑相关 
      closeExpd(item){
        this.defaultExpd = this.defaultExpd.filter(i => i !== item._id && !item.children.map(j => j._id).includes(i))
      },
      openExpd(item){
        this.defaultExpd = [...this.defaultExpd, item._id]
      },
      // 点击 树状图 展开
      expandedTree(data, event){
        this.$refs["tree_"+ data._id].parentNode.previousElementSibling.click();
        event.stopPropagation();
      },
      // 点击 树状图 切换
      changeTree(data, event){
        this.dept_id = data._id;
        event.stopPropagation();
        return false
      },
      // 树状图筛选方法
      filterNode(value, data) {
        if (!value||!data) return true;
        return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },

    // 弹窗
      change_dept_submit () {
        this.$confirm(this.$I18n("move_member_warn"), this.$I18n("warning"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.$api.s_Member({
            tran_ids: this.selTable.map(i => i.id),
            dept_id: this.tree_select_modal_data.id,
          })
            .then(this.$Then(() => {
              this.$successMsg(this.$I18n("move_succ"));
              this.api_getPageData();
              this.$refs.change_dept.close();
            }))
            .catch(this.$Catch(this.$I18n("move_fail")))
        }).catch(() => { })
      },
      closeModal(){  },
      // 获取对应ID的部门数据
      getDeptData(id, arrayData){
        if(!id || !arrayData || arrayData.length === 0 ){
          return {
            name: "",
          }
        }
        for(var i=0; i < arrayData.length; i++){
          if(arrayData[i]._id == id){
            return arrayData[i];
          }
          if(arrayData[i].children && arrayData[i].children.length > 0){
            let res = this.getDeptData(id, arrayData[i].children);
            if(res.name){
              return res
            }
          }
        }
        return {
          name: "",
        }
      },

    // 表格相关
      goSearch(){
        this.searchData = {...this.searchForm}
        this.currentPage = 1;
        this.api_getPageData();
        this.noRepeat = true;
      },
      resetSearch(){
        this.searchForm = {
          like: "",
          list_type: 0,
        }
      },
      table_selectMember(item){
        this.selTable = item;
      },
      // 批量删除 
      batchDelete(){
        if(this.selTable.length === 0){
          this.$errorMsg(this.$I18n("pls_select_del_member"), 3000);
          return
        }
        this.$confirm(this.$I18n("check_batch_delete_member"), this.$I18n("warning"), {
          confirmButtonText: this.$I18n("sure"),
          cancelButtonText : this.$I18n("cancle"),
          type: 'warning'
        }).then(() => {
          this.$api.d_Member({
            home_id: this.sel_organi,
            ids: this.selTable.map(i => i.id),
          })
            .then(this.$Then(() => {
              this.$successMsg(this.$I18n("delete_success"));
              this.api_getPageData();
              this.$refs.change_dept.close();
            }))
            .catch(this.$Catch(this.$I18n("delete_fail")))
        }).catch(() => { })
      },
      // 打开 人员批量转移部门 弹窗
      table_changeMemberDept(){
        if(this.selTable.length === 0){
          this.$errorMsg(this.$I18n("pls_select_move_member"), 3000);
          return
        }
        this.tree_filter_modal = "";
        this.tree_select_modal = this.dept_id;
        this.$refs.change_dept.open();
      },
    // 人员弹窗相关 
      table_addUser(){
        this.$refs.member.open("add");
      },
      table_editUser(data){
        this.$refs.member.open("edit", data);
      },
      table_delUser(data){
        this.$refs.member.open("del", data);
      },

    // 部门弹窗相关
      table_addDept(){
        this.$refs.dept.open("add");
      },
      table_setDept(data){
        this.$refs.dept.open("edit", data);
      },
      table_delDept(data){
        this.$refs.dept.open("del", data);
      },
    // 数据处理
      // 重新获取部门      
      regetDept(type){
        this.api_getDepart();
        if(type === "del"){
          var defDept = this.deptData.filter(i => i.def === 1)
          this.dept_id = defDept[0]._id;
        }
      },
      // 获取 部门
      api_getDepart(){
        return this.$api.g_OrganiDepart({
          home_id: this.sel_organi,
        })
          .then(this.$Then(res => {
            this.set_dept(res.data.depts);
            this.$emit('reget_organi');
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.deptData = [];
          }))
      },
      // 获取 人员
      api_getPageData(){
        if(this.noRepeat){
          return
        }
        return this.$api.g_Member({
          ...this.searchData,
          home_id : this.sel_organi,
          dept_id : this.dept_id.replace("d_", ""),
          page_no : this.currentPage,
          page_size: this.pageSize,
        })
          .then(this.$Then(res => {
            this.selTable = [];
            this.total = res.count
            this.tableData = res.data.map(i => {
              const deptInfo = this.deptData.filter(j => j.id === i.dept_id)[0]
              let dept_name = deptInfo ?deptInfo.name :"";

              return {
                ...i,
                dept_name,
                list_state_name : this.$I18n(this.$Param.memberListState.getName(i.list_type)),
                person_type_name: this.$I18n(this.$Param.memberPersonType.getName(i.state)),
              }
            });
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.selTable = [];
            this.tableData = [];
            this.total = 0 ;
          }))
          .then(() => {
            this.noRepeat = false;
          })
      },
      // 设置部门 _id
      set_dept_id(depts){
        return depts.map(i => {
          if(i.children && i.children.length > 0){
            this.defaultExpd.push("d_" + i.id)
          }
          return {
            ...i,
            _id: "d_" + i.id,
            children: i.children && i.children.length>0 ?this.set_dept_id(i.children) :null,
          }
        })
      },
      // 变成 Main.children[Sub] 格式
      setChildren(deptList){
        var indexMap = {};
        deptList = deptList.map((i, index) => {
          indexMap[i.id] = index;
          return {
            ...i,
            children: [],
          }
        });
        deptList.forEach(i => {
          if(i.parent_id !== "0"){
            deptList[indexMap[i.parent_id]].children.push(i);
          }
        });
        return deptList.filter(i => i.parent_id === "0")
      },
      // 设置部门参数
      set_dept(deptList){
        this.deptData = this.set_dept_id(this.setChildren(deptList));
        var defDept = this.deptData.filter(i => i.def === 1)
        if(defDept.length > 0 && this.dept_id === 0){
          this.dept_id = defDept[0]._id;
        }
      },
  },
}
</script>
<style scoped>
  .ex-shadow {
    position:absolute; 
    top: 42px;
    bottom: 0;
    left: 0;
    right: 0;
    background: url("/img/haiqora/ex-qr.png");
    background-size: 100% 100%; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ex-icon{
    font-size: 45px !important;
    color: #FFFFFF !important;
  }
  /* Label 额外信息 ICON */
  .more-info-span{
    border: 1px solid #578EFF;
    height: 12px;
    width: 12px;
    line-height: 12px;
    color: #578EFF;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 800;
    font-style: normal;
  }
  .qrcode-box h4{
    font-size: 16px;
    font-weight: 400;
  }
  .qrcode-box .qr-box{
    width:340px; 
    background: #F2F4F8;
    margin: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .qr-box .qr-info{
    width: 100%;
    background: #E7EAF1;
    text-align: center;
    font-size: 14px;
    line-height: 42px;
  }
  .qr-box .qr-img{
    width: 310px;
    margin: 18px auto 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /*TREE*/
  .selected-tree .el-tree-node__expand-icon{
    color: #FFF !important;
  }
  /*TREE END*/
  .table-image{
    max-width: 38px;
    max-height: 38px; 
    height: auto; 
    width: auto;
  }
  .custom-tree-node{
    margin-left: -25px;
    height: 30px;
    line-height: 30px;
    padding-left: 6px;
    width: 100%;
  }
  .diy-tree-node{
    padding-right: 30px;
  }
  .diy-tree-node .md-icon.md-theme-default.md-icon-font{
    transition: none;
  }
  .diy-tree-node .diy-tree-title{
    margin-left: 4px;
    max-width: calc(100% - 37px);
    position: absolute;
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .diy-tree-node{
    background: #FFF;
  }
  .diy-tree-node.selected-tree {
    background: #578EFF;
    color: #FFF;
  }
  .selected-tree .md-icon.md-theme-default.md-icon-font{
    color: #FFF;
  }
  .search-icon{
    font-size: 18px !important; 
    position: absolute;
    right: 4px;
    top: 2px;
    cursor: pointer;
  }
  .table-button-box button{
    margin-right: 25px;
  }
  .table-form-box{
    display:flex;
    align-items:center;
    flex-wrap: wrap;
  }
  .table-form-box button{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .table-form-box button:nth-of-type(1){
    margin-right:25px;
  }
  .diy-blue.md-button.has-button.svg-icon /deep/ .md-ripple{
    padding-left: 10px !important;
  }
</style>